<template>
    <div id="root">
          <slot></slot>
    </div>
</template>

<script>
export default {
    name:"Root"
}
</script>

<style scoped>
    #root{
        background-color: #3A4861;
        display: inline-block;
        height: auto;
        width: 100%;
    }
</style>